import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IUpdateConfigPtMonMedidor } from "../types";

const DTO = (data: IUpdateConfigPtMonMedidor) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    valor,
    diaMedicao,
    limiteSup,
    limiteInf,
    timeLog,
    coordX,
    coordY,
    offSet,
    calibracaoEscala,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    valor: Number(valor),
    diaMedicao: Number(diaMedicao),
    limiteSup: Number(limiteSup),
    limiteInf: Number(limiteInf),
    timeLog: Number(timeLog),
    coordX: Number(coordX),
    coordY: Number(coordY),
    offSet: Number(offSet),
    calibracaoEscala: Number(calibracaoEscala),
    timeMsgEscaladaNV2: `${checkDataEscalada(hrMsgEscaladaNV2)}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(hrMsgEscaladaNV3)}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgFalhaAcimaCustom: "",
    msgFalhaAbaixoCustom: "",
    msgNormalCustom: "",
  };
};

export const updateConfigPtMonMedidor = async (
  idPt: string,
  props: IUpdateConfigPtMonMedidor,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonMedidor/${idPt}`;
    const data = DTO({
      ...props,
    });
    const result = await request({
      url,
      method: "put",
      data,
      headers: { "Content-Type": "application/json" },
    });

    if (result.data.toLowerCase() === "ok") {
      toast.success("Ponto de monitoramento atualizado com sucesso.");
      return result;
    } else {
      toast.error(
        "Erro ao processar a requisição. Por favor, tente novamente.",
      );
      throw new Error(result.data);
    }
  } catch (error: any) {
    const apiError = error.response?.data;

    if (process.env.NODE_ENV === "development") {
      console.error("Datalhes do Erro:", apiError);
    }

    let mensagemExibicao = "Erro ao processar a requisição.";

    if (apiError?.errors) {
      const detalhes = Object.values(apiError.errors).flat().join(" | ");
      mensagemExibicao = detalhes;
    } else if (apiError?.title) {
      mensagemExibicao = apiError.title;
    }

    toast.error(mensagemExibicao, {
      description: "Verifique os campos e tente novamente.",
    });
  }
};
